import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Question, QuestionMeta, Section } from '../../../../../types'
import { TestService } from '../../../../../services/test.service'

@Component({
  selector: 'app-labeling-question',
  templateUrl: './labeling-question.component.html',
  styleUrls: ['./labeling-question.component.scss']
})
export class LabelingQuestionComponent implements OnInit {
  /**
   * The Section object
   */
  @Input('section') section: Section
  /**
   * Question Meta that is 'selected' for this Question
   */
  @Input('questionMeta') questionMeta: QuestionMeta
  /**
   * The Question object
   */
  @Input('question') question: Question
  /**
   * Emitter that tells whether this question type component has reached an answered state
   */
  @Output() answered = new EventEmitter<boolean>()

  /**
   * Refers to the numbering of the field inputs
   */
  public blanks: number[]

  /**
   * Refers to the inputs model to store the field values
   */
  public inputs: { [key: string]: string }
  constructor(private testService: TestService) {}

  ngOnInit(): void {
    // Load the answer value if it exists
    const inputs = this.testService.getAnswerValue(this.question.id)

    // FIll for the numbering
    this.blanks = Array(this.questionMeta.items.length)
      .fill(0)
      .map((x, i) => i + 1)

    // Then setup the input fields (so that they are non null)
    this.inputs = this.blanks.reduce((acc, cur) => {
      if (!acc[cur]) {
        acc[cur] = ''
      }
      return acc
    }, inputs || {})

    // Always check upon init
    this.checkIfAnswered()
  }

  onChange(value, name) {
    // Update the answer value
    this.testService.updateAnswerValue(
      this.section,
      this.question,
      this.questionMeta,
      // Use map form, name would be the item#
      // Value would be the field value
      { [name]: value }
    )
    // When there are changes to the answer
    // check if all fields were answered and
    // use answer emitter
    this.checkIfAnswered()
  }

  private checkIfAnswered() {
    // Map the inputs to their value
    const allAnswered = Object.keys(this.inputs)
      .map(k => this.inputs[k])
      // Check tha all values have length
      .every(value => {
        return value && value.length > 0
      })
    this.answered.emit(allAnswered)
  }
}
